<template><!-- add is-sized-up to BaseModal with verification codes -->
  <BaseModal class="modal-contact" modal-id="modalContact" :show-modal="showModal">
    <template #heading>Send confirmation</template>
    <template #content><span><!-- fix for mysterious non-showing content locally --></span>
      <!-- <form> -->
        <ContactPhone :is-modal="Boolean(true)" @doPhone="setPhone" @doResetVerify="resetSendNow" />
        <p hidden ref="invalidPhoneMsg" class="app-invalid-msg bad-phone">Please enter a valid phone number.</p>
        <ContactEmail :is-modal="Boolean(true)" @doEmail="setEmail" @doResetVerify="resetSendNow" />
        <p hidden ref="noContactInfo" class="app-invalid-msg msg-offset-1">
            Email is required.
          </p>
          <p></p>
    </template>
    <template #footing>
      <div class="footer-offset">
        <ModalDisclaimer @doDisclaimer="adjustModalHeight" />
        <BaseButtonGroup>
          <button type="button" @click="closeModal">Cancel</button>
          <CustomButton type="submit" @click="notifyMe">Send</CustomButton>
        </BaseButtonGroup>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { phoneMixin } from '@/utils/phoneMixin'
import BaseModal from '@/components/ui/BaseModal'
import ContactPhone from '@/components/contact/ContactPhone'
import ContactEmail from '@/components/contact/ContactEmail'
import ModalDisclaimer from '@/components/confirmation/ModalDisclaimer'
import BaseButtonGroup from '@/components/ui/BaseButtonGroup'
import * as COMMONS from '../../store/_commons';
import CustomButton from '../CustomButton.vue';

export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    }
  },
  components: {
    BaseModal,
    ContactPhone,
    ContactEmail,
    ModalDisclaimer,
    BaseButtonGroup,
    CustomButton
  },
  mixins: [
    phoneMixin,
  ],
  computed: {
    ...mapState([
      'LANG',
      'STATUSES',
      'networkResponse',
    ]),
    language() {
      return this.LANG;
    },
  },
  data() {
    return {
      myPhone: '',
      myEmail: '',
      isPhoneValidated: true,   // true onload since only valid data should pass thru from previous actions
      isEmailValidated: true,
      sendNow: false,
    };
  },
  async mounted() {

  },
  methods: {
    ...mapActions({
        getSendTransactionConfiramtion: COMMONS.GUEST_SENDTRANSACTIONCONFIRMATION,
      }  
    ),
    adjustModalHeight(e) {
      const collapsed = e;
      const modalContent = document.querySelector('.app-modal-content');
      const overflowSelector = '__overflow';
      if (collapsed) {
        modalContent.classList.remove(overflowSelector);
      } else {
        // 400px from media query max-height
        if ((screen.height > 400) && (modalContent.offsetHeight > (screen.height * 0.9))) {
          modalContent.classList.add(overflowSelector);
        }
      }
    },
    closeModal() {
      this.sendNow = false;
      // close modal so that network error message from middle tier will be displayed unblocked
      this.$emit('doClose');
    },
    hasContactInfo() {
      return (this.myEmail.length > 0);
    },
    handleNotificationResponse(response) {
      this.$emit('doNotificationMessage', {
        isConsentProvided: true,
        isEmailSentSuccessfully: response.isEmailSentSuccessfully,
        isSmsSentSuccessfully: response.isSmsSentSuccessfully,
      });

      // close modal - let parent take care of notification status
      this.closeModal();
    },
    /**
     * User hits the Send button.
     */
    notifyMe() {
      this.sendNow = true;
      this.sendNotification();
    },
    resetSendNow() {
      // prevent auto send upon valid validations from children's watchers
      this.sendNow = false;
    },
    /**
     * Request backend to send notification(s) if everything checks out.
     */
    async sendNotification() {
      // workaround - emulate child component's phone validation
      if (!this.validatePhoneAgain()) {
        this.sendNow = false;
        return;
      }

      // show/hide required field message
      const hasContact = this.hasContactInfo();
      this.toggleContactInfoCheck(hasContact);

      // send notification IFF at least one good contact is provided and there are no standing errors
      if (this.sendNow && this.isEmailValidated && this.isPhoneValidated && hasContact) {
        const formattedPhoneNum = this.formatPhoneForRims(this.myPhone);
        const data = {
          // appointmentNumber: this.resAppointmentNum,  // "required" only for RIMS email/sms notifications (?)
          email: this.myEmail,
          isConsentProvided: true,
          phone: formattedPhoneNum,
          onlineTransactionCartId:this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.transactionCartId.toString()
        }

        // user might have overridden their info...
        this.updateContactInfo(data);

        // wait for send response...
        // const response = await this.getSendTransactionConfiramtion(data);
      }

      // prevent data from being submitted without user's explicit choice
      this.resetSendNow();
    },
    /**
     * Depend on ContactEmail myEmail watcher.
     */
    setEmail(data) {
      this.myEmail = data.email;
      this.isEmailValidated = data.isValid;


    },
    /**
     * Depend on ContactEmail myPhone watcher.
     */
    setPhone(data) {
      this.myPhone = data.phone;
      this.isPhoneValidated = data.isValid;


    },
    /**
     * Show or hide required field message based on user input.
     * @param hasContact
     */
    toggleContactInfoCheck(hasContact) {
      const elem = this.$refs.noContactInfo;
      if (hasContact) {
        elem.setAttribute('hidden', 'hidden');
      } else {
        elem.removeAttribute('hidden');
      }
    },
    /**
     * Refresh session data (phone, email, consent) in case user has provided new info.
     * @param data
     */
    async updateContactInfo(data) {
      const paymentSendConfirmationRequest = {
          email: data.email,
          phone: data.phone,
          isConsentProvided: true,
          // isModifyRequest: this.isModify,
          onlineTransactionCartId:this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.transactionCartId.toString()
        }
     this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.email = paymentSendConfirmationRequest.email;
     this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.phone = paymentSendConfirmationRequest.phone;
      const response = await this.getSendTransactionConfiramtion(paymentSendConfirmationRequest);
      try {
        await this.handleNotificationResponse(response);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Many issues with ValidationObserver when validations are NOT done within the same component AND child-to-parent
     * $emits are involved. Decided to just do an extra phone validation here to avoid accidentally breaking
     * ContactPhone validation for UserContact and wasting even more time.
     * @returns {boolean}
     */
    validatePhoneAgain() {
      const ac = document.getElementById('userPhoneAC');
      const f3 = document.getElementById('userPhoneF3');
      const l4 = document.getElementById('userPhoneL4');
      const phone2 = `${ac.value || ''}${f3.value || ''}${l4.value || ''}`;

      let okay = true;
      if (phone2.length > 0) {
        if (/^\d+$/.test(phone2)) {
          okay = phone2.length === 10;
        } else {
          // child component validation would have kicked in so no further parent intervention needed
          okay = false;
        }

        // toggle message on user tapping 'Send' only
        if (this.sendNow && this.isPhoneValidated) {
          this.toggleInvalidPhoneMsg(!okay);
        }
      }

      return okay;
    },
    toggleInvalidPhoneMsg(forceShow) {
      const elem = this.$refs.invalidPhoneMsg;
      if (forceShow) {
        // parent to show error message similar to the one in child component
        elem.removeAttribute('hidden');
      } else {
        elem.setAttribute('hidden', 'hidden');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-contact {
  form {
    button.verify {   // for verification code (future phase)
      display: inline-block;
      min-width: unset;
    }
    &::v-deep {       // pass to child components
      --field-padding: 1em;
      fieldset {
        legend {
          background-color: var(--ri-light-gray);
          padding: var(--field-padding);
          width: 100%;
        }
        .app-contact-inputs {
          padding: var(--field-padding) 0 var(--field-padding) var(--field-padding);
          --box-width: 320px !important;
          --box-width-tiny: calc(var(--box-width) * 0.85) !important;

        }
        .app-input-group .app-contact-info{
            .app-user-email {
              @media only screen and (max-width: 425px) {
                min-width: var(--box-width-tiny);
              }
            }
          } 
      }
    }
    p {
      margin: -0.75em 0 1em;
      &.bad-phone {
        margin: -1.75em 0 1.5em 1em;
      }
    }
    input {
      margin-bottom: 1em;
      ~ p {
        width: unset;
      }
    }
    .msg-offset {
      margin-top: -2em;
    }
  }
  .footer-offset {
    margin-top: -3rem;
  }
}

</style>
